import type { CustomEffectsEvent } from '@entities/overlay-event'
import type { EffectComponentProps } from '@shared/lib/effect-registry'

import { EffectErrorBoundary } from '@shared/ui/EffectErrorBoundary'

import { CustomEffectRender } from './CustomEffectRender'

/**
 * Компонент плагина custom_effects. Оборачивает рендер в ErrorBoundary:
 * при ошибке рендера дёргается onDone → эксклюзивная очередь не застревает.
 */
export function CustomEffect(props: EffectComponentProps<CustomEffectsEvent>) {
  return (
    <EffectErrorBoundary onError={props.onDone}>
      <CustomEffectRender {...props} />
    </EffectErrorBoundary>
  )
}
